export const quotationsState: aboTheme.IState = {
    parent: "app",
    name: "quotations",
    url: "/quotations",
    redirectTo: "quotations.proforma",
    component: "quotationsComponent",
    data: {
        permissions: {
            only: ['FINANCE'],
            redirectTo: 'schedule'
        }
    }
};

export const quotationProformaState: aboTheme.IState = {

    name: "quotations.proforma",
    url: "/proforma",
    params: {
        proformaInvoicesOnly: true
    },
    views: {
        "main": 'quotationsDashboardComponent'
    }
};

export const quotationCootjeState: aboTheme.IState = {

    name: "quotations.cootje",
    url: "/cootje",
    params: {
        proformaInvoicesOnly: true
    },
    views: {
        "main": 'quotationsCootjeComponent'
    }
};

export const quotationDashboardState: aboTheme.IState = {

    name: "quotations.dashboard",
    url: "/dashboard",
    params: {
        proformaInvoicesOnly: false
    },
    views: {
        "main": 'quotationsDashboardComponent'
    }
};

export const quotationSummaryState: aboTheme.IState = {

    name: "quotations.summary",
    url: "/summary",
    views: {
        "main": 'quotationsSummaryComponent'
    },
    data: {
        permissions: {
            only: ['FINANCE'],
            redirectTo: 'schedule'
        }
    }
};

export const quotationComparisonState: aboTheme.IState = {

    name: "quotations.comparison",
    url: "/comparison",
    views: {
        "main": 'quotationsComparisonComponent'
    },
    data: {
        permissions: {
            only: ['FINANCE'],
            redirectTo: 'schedule'
        }
    }
};


// WEBPACK FOOTER //
// ./src/app/modules/quotations/quotations.states.ts